import m from "../../geodata/es2015/worldIndiaUltra";
window.am4geodata_worldIndiaUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/worldIndiaUltra.js
// module id = null
// module chunks = 